
import { Mic } from "lucide-react";

const Header = () => {
  return (
    <header className="w-full py-4 px-6 bg-white dark:bg-gray-800 shadow-sm">
      <div className="container mx-auto flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Mic className="h-6 w-6 text-indigo-600 dark:text-indigo-400" />
          <h1 className="text-xl font-bold text-gray-900 dark:text-white">
            Speech Emotion Buddy
          </h1>
        </div>
        <div className="text-sm text-gray-500 dark:text-gray-400">
          Powered by Deep Reinforcement Learning
        </div>
      </div>
    </header>
  );
};

export default Header;
